"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = void 0; // eslint-disable-next-line import/prefer-default-export

var sizes = {
  XS: 'XS',
  SM: 'SM',
  MD: 'MD',
  LG: 'LG',
  XL: 'XL'
};
exports.sizes = sizes;